import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth.jsx";
import { toast } from "sonner";
import { Toaster } from "../components/ui/sonner";

const LOGO = "https://i.imgur.com/27IUlf9.png";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Bienvenido");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al iniciar sesión");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f7f7f4] flex items-center justify-center p-6">
      <form onSubmit={onSubmit} className="eu-card w-full max-w-md p-8 lg:p-10" data-testid="admin-login-form">
        <img src={LOGO} alt="Euzerone" className="h-10 mx-auto" />
        <div className="eu-data-label mt-6 text-center">PANEL ADMINISTRADOR</div>
        <h1 className="font-display text-3xl text-[#133322] text-center mt-2">Iniciar sesión</h1>
        <div className="mt-8 space-y-4">
          <div>
            <label className="eu-data-label block mb-2">Email</label>
            <input required type="email" value={email} onChange={(e)=>setEmail(e.target.value)} className="w-full bg-[#f7f7f4] rounded-xl px-4 py-3 text-sm border border-[#e5e8e2] focus:border-[#133322] outline-none" data-testid="admin-email" />
          </div>
          <div>
            <label className="eu-data-label block mb-2">Contraseña</label>
            <input required type="password" value={password} onChange={(e)=>setPassword(e.target.value)} className="w-full bg-[#f7f7f4] rounded-xl px-4 py-3 text-sm border border-[#e5e8e2] focus:border-[#133322] outline-none" data-testid="admin-password" />
          </div>
        </div>
        <button type="submit" disabled={busy} className="eu-btn-primary w-full justify-center mt-8" data-testid="admin-login-submit">
          {busy ? "Entrando..." : "Iniciar sesión"}
        </button>
        <div className="mt-6 text-center text-xs text-[#5c6b61] space-y-2">
          <div><a href="/admin/forgot" className="hover:text-[#133322]" data-testid="forgot-link">¿Olvidaste tu contraseña?</a></div>
          <div><a href="/" className="hover:text-[#133322]">← Volver al sitio</a></div>
        </div>
      </form>
      <Toaster richColors position="top-center" />
    </div>
  );
}
